export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('hotels');
    if (element && element.length) {
        params.hotels = element.pluck('id').join('.');
    }

    return params;
};